import React from 'react';
import Navbar from "../components/Navbar";
import Service from "../components/Service";
import Choose from "../components/WhyChooseUs"
import Footer from "../components/Footer";

function ServicesPage() {
    return (
    <main>
        <Navbar/>
        <Service/>
        <Choose/>
        <Footer/>
    </main>
    )
}

export default ServicesPage;